<!--
 * @Author: owen
 * @Date: 2022-03-30 14:30:17
 * @LastEditors: owen
 * @LastEditTime: 2022-03-30 17:25:20
 * @FilePath: \app-h5web\src\components\QRCode\index.vue
-->
<template>
  <div>
    <div :id="'qrcode_' + idName" class="qrcode"></div>
    <div v-if="qrText">{{ qrText }}</div>
  </div>
</template>

<script>
import QRCode from "@/lobby_common/mixins_components/QRCode/index.js";
export default {
  components: {},
  props: [],
  mixins: [QRCode],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.qrcode {
  display: inline-block;
  border: 1px solid #f1f1f1;
  // border-radius: 3px;
  text-align: center;
  margin: 0 auto;
  > img {
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
